import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=5f3d17d7&scoped=true&"
import script from "./Quiz.vue?vue&type=script&lang=js&"
export * from "./Quiz.vue?vue&type=script&lang=js&"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=5f3d17d7&scoped=true&lang=css&"
import style1 from "./Quiz.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d17d7",
  null
  
)

export default component.exports